import AddGuarantee from "../pages/guarantee/addGuarantee";
import EditGuarantee from "../pages/guarantee/editGuarantee";
import GuaranteeIndex from "../pages/guarantee/guarantee";



const guaranteeRoutes = [
  {
    path: "guarantee",
    element: <GuaranteeIndex />,
  },
  {
    path: "guarantee/add",
    element: <AddGuarantee />,
  },
  {
    path: "guarantee/edit/:id",
    element: <EditGuarantee />,
  },
];

export default guaranteeRoutes;